import type { SeriesDto } from './connector-next-schemas';

/**
 * Selection key of a series: stable id, DICOM series UID fallback; undefined =
 * not selectable. The single source of truth shared by the patient-list
 * selection UI and the open-in-viewer resolver, so both key datasets the same
 * way regardless of layer.
 */
export function seriesKey(series: SeriesDto): string | undefined {
    return series.id ?? series.seriesInstanceUid ?? undefined;
}
